module.exports = __webpack_public_path__ + "img/arrow-right.afa3075c.svg";